import { render } from "./SpecialGfOffer.vue?vue&type=template&id=ad718ef4&scoped=true"
import script from "./SpecialGfOffer.vue?vue&type=script&lang=js"
export * from "./SpecialGfOffer.vue?vue&type=script&lang=js"

import "./SpecialGfOffer.vue?vue&type=style&index=0&id=ad718ef4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad718ef4"]])

export default __exports__